module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1006-2998bfdc942469201a32d2e500dc6459.png";